export const MODELO = {
  CTE: '57',
  NFE: '55',
  NFCE: '65',
  SAT: '59',
  MDFE: '58',
  GERENCIAL: 'GR',
};

export const MODELO_LABEL = {
  [MODELO.CTE]: 'CT-e',
  [MODELO.NFE]: 'NF-e',
  [MODELO.NFCE]: 'NFC-e',
  [MODELO.SAT]: 'SAT',
  [MODELO.MDFE]: 'MDFe',
  [MODELO.GERENCIAL]: 'Pré-venda Gerencial',
};

export const PRINT = {
  NORMAL: 1,
  REDUCED: 2,
};

export const PRINT_LABEL = {
  [PRINT.NORMAL]: 'Impressão normal',
  [PRINT.REDUCED]: 'Impressão reduzida',
};
